<ngx-spinner [visible]="showSpinner" [config]="spinnerConfig"></ngx-spinner>
